import { createSelector } from '@ngrx/store';

import { createSingleEntityStore, getSingleEntityActions } from '@recruitee/ngrx';
import type { RequisitionsConfig } from '@recruitee/requisitions-types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<RequisitionsConfig>()(
  'RequisitionsConfig',
  {
    customActions: adapter => {
      const actions = getSingleEntityActions(adapter);
      return {
        updateWithDepartments: (
          state,
          payload: Partial<RequisitionsConfig> & { defaultApprovalFlowId?: number },
        ) => adapter.markAsPending(state),
        updateWithDepartmentsSuccess: actions.updateSuccess,
        updateWithDepartmentsFailed: actions.updateFailed,
        updateRequiredForOffers: actions.update,
        updateRequiredForOffersSuccess: actions.updateSuccess,
        updateRequiredForOffersFailed: actions.updateFailed,
        updateAutoCreateJobs: actions.update,
        updateAutoCreateJobsSuccess: actions.updateSuccess,
        updateAutoCreateJobsFailed: actions.updateFailed,
        enable: state => adapter.markAsPending(state),
        enableSuccess: actions.updateSuccess,
        enableFailed: actions.updateFailed,
        disable: state => adapter.markAsPending(state),
        disableSuccess: actions.updateSuccess,
        disableFailed: actions.updateFailed,
      };
    },
  },
);

const RequisitionsConfigSelectors = {
  ...selectors,
  isDepartmentsMode: createSelector(
    selectors.data,
    state => !!state?.departmentsRequiredForApprovalFlows && !!state?.enabled,
  ),
  requisitionsFeatureEnabled: createSelector(selectors.data, state => !!state?.enabled),
};

export {
  RequisitionsConfigSelectors,
  actions as RequisitionsConfigActions,
  reducer as RequisitionsConfigReducer,
  namespace as RequisitionsConfigNamespace,
};
